import classNames from 'classnames';
import Image from 'next/image';
import React from 'react';

import Counter from '~/shared/components/counter';

import './about-us-block.scss';

type AboutAuthorBlockPropsType = {
  t: (key: string, options: { ns: string[] }) => string;
};

const AboutUsBlock = ({ t, description, image, title }: AboutAuthorBlockPropsType) => (
  <section className="about-us-block">
    <div className={classNames('container', 'about-us-block__container')}>
      <div className="about-us-block__content">
        <Image
          loading="lazy"
          priority={false}
          className="about-us-block__author"
          alt={title}
          title={title}
          src={image}
          width={768}
          height={591}
        />
        <div className="about-us-block__description-block">
          <h3 className="about-us-block__title">{title}</h3>
          <div className="about-us-block__description">{description}</div>
          <div className="about-us-block__description-subtitle">{t('text.our-program-helped')}:</div>
          <div className="about-us-block__count-block">
            <div className="about-us-block__count-block-item">
              <div className="about-us-block__count-block-item-count">
                <Counter className="about-us-block__counter" noPrefix number={700} />
                <div className="about-us-block__counter-plus">+</div>
              </div>
              <div className="about-us-block__students-online">{t('text.students-online')}</div>
            </div>
            <div className="about-us-block__count-block-item">
              <div className="about-us-block__count-block-item-count">
                <Counter className="about-us-block__counter" noPrefix number={100} />
                <div className="about-us-block__counter-plus">+</div>
              </div>
              <div className="about-us-block__students-online">{t('text.students-offline')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutUsBlock;
